export class VehicleType {
    public vehicleTypeId: number;
    public description: string;
    public order: number;
}